const navbar=document.getElementById('navbar');if(navbar){window.addEventListener('scroll',()=>navbar.classList.toggle('scrolled',window.scrollY>20),{passive:true});}
const hamburger=document.getElementById('hamburger');const mobileMenu=document.getElementById('mobile-menu');if(hamburger&&mobileMenu){hamburger.addEventListener('click',()=>{const isOpen=mobileMenu.classList.toggle('open');hamburger.classList.toggle('open',isOpen);hamburger.setAttribute('aria-expanded',isOpen?'true':'false');});document.querySelectorAll('.mobile-link').forEach(link=>link.addEventListener('click',()=>{mobileMenu.classList.remove('open');hamburger.classList.remove('open');hamburger.setAttribute('aria-expanded','false');}));}
document.querySelectorAll('a[href^="#"]').forEach(anchor=>anchor.addEventListener('click',e=>{const href=anchor.getAttribute('href');if(!href||href==='#')return;const target=document.querySelector(href);if(target){e.preventDefault();window.scrollTo({top:target.offsetTop-86,behavior:'smooth'});}}));
function fhTrack(name,params={}){const payload={event:name,page_path:location.pathname,page_title:document.title,...params};window.dataLayer=window.dataLayer||[];window.dataLayer.push(payload);if(typeof window.gtag==='function'){window.gtag('event',name,params);}document.dispatchEvent(new CustomEvent('fixhub:interaction',{detail:payload}));}
document.addEventListener('click',e=>{const a=e.target.closest('a');if(a){const href=a.getAttribute('href')||'';if(href.includes('wa.me/'))fhTrack('whatsapp_click',{link_text:(a.textContent||'').trim(),destination:href});else if(href.startsWith('tel:'))fhTrack('phone_click',{destination:href});else if(href.startsWith('mailto:'))fhTrack('email_click',{destination:href});}const checkout=e.target.closest('[name="checkout"]');if(checkout)fhTrack('begin_checkout_click');});
document.addEventListener('submit',e=>{const form=e.target;if(form&&form.action&&form.action.includes('/cart/add'))fhTrack('add_to_cart_click');});


(function(){
  const lang=(document.documentElement.lang||'it').slice(0,2).toLowerCase();
  const prefix=lang==='it'?'':'/'+lang;
  const map={
    de:{
      paths:{
        '/pages/servizi-di-riparazione':'/pages/reparaturservices',
        '/pages/vendi-il-tuo-dispositivo-rotto':'/pages/defektes-geraet-verkaufen',
        '/pages/chi-siamo':'/pages/ueber-uns',
        '/pages/contact':'/pages/kontakt',
        '/collections/ricambi-usati-testati':'/collections/gepruefte-gebrauchte-ersatzteile',
        '/collections/dispositivi-riparati':'/collections/reparierte-geraete',
        '/pages/note-legali-impressum':'/pages/impressum',
        '/pages/privacy':'/pages/datenschutz',
        '/pages/condizioni-generali-vendita':'/pages/allgemeine-geschaeftsbedingungen',
        '/pages/spedizione-consegna':'/pages/versand-lieferung',
        '/pages/resi-reclami-garanzia':'/pages/rueckgabe-reklamation-garantie',
        '/pages/prodotti-usati-riparati':'/pages/bedingungen-gebrauchte-reparierte-produkte'
      },
      footer:['Impressum','Datenschutz','AGB','Versand & Lieferung','Rückgabe & Garantie','Gebrauchte & reparierte Produkte'],
      langLabel:'Sprache',menuLabel:'Menü'
    },
    en:{
      paths:{
        '/pages/servizi-di-riparazione':'/pages/repair-services',
        '/pages/vendi-il-tuo-dispositivo-rotto':'/pages/sell-broken-device',
        '/pages/chi-siamo':'/pages/about-us',
        '/pages/contact':'/pages/contact',
        '/collections/ricambi-usati-testati':'/collections/tested-used-spare-parts',
        '/collections/dispositivi-riparati':'/collections/repaired-devices',
        '/pages/note-legali-impressum':'/pages/legal-notice',
        '/pages/privacy':'/pages/privacy-policy',
        '/pages/condizioni-generali-vendita':'/pages/terms-and-conditions',
        '/pages/spedizione-consegna':'/pages/shipping-delivery',
        '/pages/resi-reclami-garanzia':'/pages/returns-complaints-warranty',
        '/pages/prodotti-usati-riparati':'/pages/used-repaired-products-terms'
      },
      footer:['Legal notice','Privacy','Terms & conditions','Shipping & delivery','Returns & warranty','Used & repaired products'],
      langLabel:'Language',menuLabel:'Menu'
    },
    fr:{
      paths:{
        '/pages/servizi-di-riparazione':'/pages/services-reparation',
        '/pages/vendi-il-tuo-dispositivo-rotto':'/pages/vendre-appareil-casse',
        '/pages/chi-siamo':'/pages/a-propos',
        '/pages/contact':'/pages/contact',
        '/collections/ricambi-usati-testati':'/collections/pieces-occasion-testees',
        '/collections/dispositivi-riparati':'/collections/appareils-repares',
        '/pages/note-legali-impressum':'/pages/mentions-legales',
        '/pages/privacy':'/pages/politique-confidentialite',
        '/pages/condizioni-generali-vendita':'/pages/conditions-generales-vente',
        '/pages/spedizione-consegna':'/pages/expedition-livraison',
        '/pages/resi-reclami-garanzia':'/pages/retours-reclamations-garantie',
        '/pages/prodotti-usati-riparati':'/pages/conditions-produits-occasion-repares'
      },
      footer:['Mentions légales','Confidentialité','Conditions générales','Expédition & livraison','Retours & garantie','Produits d’occasion & réparés'],
      langLabel:'Langue',menuLabel:'Menu'
    },
    it:{
      paths:{},
      footer:['Avviso legale / Impressum','Privacy','Condizioni di vendita','Spedizione e consegna','Resi e garanzia','Prodotti usati e riparati'],
      langLabel:'Lingua',menuLabel:'Menu'
    }
  };
  const cfg=map[lang]||map.it;
  document.querySelectorAll('a[href]').forEach(a=>{
    const raw=a.getAttribute('href');
    if(!raw)return;
    let path=raw;
    try{path=new URL(raw,location.origin).pathname;}catch(e){}
    const stripped=path.replace(/^\/(de|en|fr|it)(?=\/)/,'');
    const next=cfg.paths[stripped];
    if(next)a.setAttribute('href',prefix+next);
  });
  const legal=document.querySelectorAll('.fh-site-footer > .container.fh-footer-grid > div:last-child a');
  cfg.footer.forEach((label,i)=>{if(legal[i])legal[i].textContent=label;});
  const localeSelect=document.getElementById('LocaleSelector');if(localeSelect)localeSelect.setAttribute('aria-label',cfg.langLabel);
  const burger=document.getElementById('hamburger');if(burger)burger.setAttribute('aria-label',cfg.menuLabel);
})();
